
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill",attrs:{"fill":"#141414","d":"M174 95.93h-14.22v-19.6a18.42 18.42 0 00-18.42-18.42H91.89v-8.74a18.42 18.42 0 00-18.42-18.42H27.93A18.42 18.42 0 009.51 49.17V149a18.32 18.32 0 005 12.54 16 16 0 0013.71 7.69H157.1a19.41 19.41 0 0018.22-12.71l14.1-38.3A16.51 16.51 0 00174 95.93z"}}),_c('path',{staticClass:"filled fill",attrs:{"fill":"#fff","d":"M19.51 76.33V49.17a8.43 8.43 0 018.42-8.42h45.54a8.43 8.43 0 018.42 8.42v18.74h59.47a8.43 8.43 0 018.42 8.42v19.6H46.17a19.71 19.71 0 00-18.46 12.79l-8.2 21.84V76.33z"}}),_c('path',{staticClass:"filled fill",attrs:{"fill":"#fff","d":"M180.06 114.73v.06l-14.1 38.3a9.46 9.46 0 01-8.84 6.16H28.18a6.06 6.06 0 01-5.68-8.2l14.57-38.82a9.77 9.77 0 019.1-6.3H174a6.52 6.52 0 016.1 8.8z"}})])
          )
        }
      }
    